export default __webpack_public_path__ + "static/media/studentRealCase2-mobile-en.f1a3d7c4.png";